module.exports = __webpack_public_path__ + "img/Weapon_47.29fb474f.png";